import { PlusOutlined } from '@ant-design/icons';
import {
  Button, Divider, Select, Space, Typography,
} from 'antd';
import React, { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { POSHUB_MENU_DRIVER } from '../../constants';
import { MenuContext } from '../context';

function MenuSelector({ onAddNew }) {
  const { id: merchantId } = useParams();
  const {
    menus, selectedMenu, setSelectedMenu, posHubIntegrated,
  } = useContext(MenuContext);

  const posHubMenusPath = `/console/restaurants/${merchantId}/pos/menus`;

  const groupedOptions = useMemo(() => {
    if (posHubIntegrated) {
      const posHubMenus = menus?.filter((m) => m.migration_driver === POSHUB_MENU_DRIVER) ?? [];
      if (!posHubMenus.length) return [];
      return [{
        label: 'POS menus',
        options: posHubMenus.map((m) => ({ label: m.name, value: m.id })),
      }];
    }

    const posHubMenus = menus?.filter((m) => m.migration_driver === POSHUB_MENU_DRIVER) ?? [];
    const nibbleMenus = menus?.filter((m) => m.migration_driver !== POSHUB_MENU_DRIVER) ?? [];

    const groups = [];
    if (posHubMenus.length) {
      groups.push({
        label: 'POS menus',
        options: posHubMenus.map((m) => ({ label: m.name, value: m.id })),
      });
    }
    if (nibbleMenus.length) {
      groups.push({
        label: 'Nibble menus',
        options: nibbleMenus.map((m) => ({ label: m.name, value: m.id })),
      });
    }
    return groups;
  }, [menus, posHubIntegrated]);

  const showAddNibbleMenu = !posHubIntegrated && typeof onAddNew === 'function';

  const notFoundContent = posHubIntegrated && !menus?.length ? (
    <Space direction="vertical" size="small" style={{ padding: '8px 12px' }}>
      <Typography.Text type="secondary">No POS menu exists yet.</Typography.Text>
      <Typography.Link href={posHubMenusPath}>Set up menus in POS</Typography.Link>
    </Space>
  ) : null;

  return (
    <Select
      style={{ width: '100%' }}
      placeholder={posHubIntegrated && !menus?.length ? 'No POS menu synced' : 'Select menu'}
      onSelect={setSelectedMenu}
      value={menus?.length ? selectedMenu : undefined}
      options={groupedOptions}
      notFoundContent={notFoundContent ?? undefined}
      dropdownRender={showAddNibbleMenu ? (menu) => (
        <>
          {menu}
          <Divider style={{ margin: '8px 0' }} />
          <Space style={{ padding: '0 8px 4px' }}>
            <Button type="text" icon={<PlusOutlined />} onClick={onAddNew}>
              Add menu
            </Button>
          </Space>
        </>
      ) : undefined}
    />
  );
}

export default MenuSelector;
